import Validate from "../../service/ValidService";

let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  id_nhom: undefined, // required - ID trong ClickHouse
  name: undefined, // required - Tên nhóm
  description: undefined, // optional - Mô tả nhóm
};

model.validForm = {
  name: [Validate.required],
};

model.tableRules = {
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "name",
  defaultSort: ["name", "ascending"],
  fields: "id,id_nhom,name,description,probe_id",
  filters: "",
  dataSearch: {
    value: {
      name: "",
    },
    operator: {
      name: ":regex_i:",
    },
  },
};

export default model;
